export default __webpack_public_path__ + "static/media/vol1_3.b1265b24.png";